import { Amplify } from 'aws-amplify';
import { COGNITO_USER_POOL_ID, COGNITO_CLIENT_ID, COGNITO_DOMAIN } from './config';

export const configureAmplify = () => {
  const origin = window.location.origin.replace(/\/$/, "");
  console.log('[Amplify Config] Initializing with origin:', origin);

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: COGNITO_USER_POOL_ID,
        userPoolClientId: COGNITO_CLIENT_ID,
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
          requireUppercase: true,
        },
        userAttributes: {
          email: {
            required: true,
          },
        },
        signUpVerificationMethod: "code",
        loginWith: {
          oauth: {
            domain: COGNITO_DOMAIN,
            scopes: [
              "email",
              "profile",
              "openid",
              "phone",
              "aws.cognito.signin.user.admin",
            ],
            redirectSignIn: [origin],
            redirectSignOut: [origin],
            responseType: "code",
          },
        },
      },
    }
  });
};
